import React, { useEffect, useState } from 'react'
import { FiltersWrapper } from '../style'
import { Dropdown, Input } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { useDebounce } from 'use-lodash-debounce';
import { useParams } from 'react-router-dom';
import { milkSamplesIDs } from '~/Constants';

const defaultTypingFilters = {
  page: 0,
  rows: 20,
  search: '',
  column: '',
  sort: '',
  fatFrom: '',
  fatTo: '',
  proteinFrom: '',
  proteinTo: '',
  date: '',
  germCountFrom: '',
  germCountTo: '',
  cellCountFrom: '',
  cellCountTo: '',
  inhibitor: '',
  ureaFrom: '',
  ureaTo: ''
}

interface FilterProps {
  options: any
  dataFiltered: any
  handleChangeFiltersData: (dataFiltered: any) => void
  checkedFilters: any[]
  id: string
}

const Filters: React.FC<FilterProps> = (props) => {
  const {
    options,
    handleChangeFiltersData,
    dataFiltered,
    checkedFilters
  } = props
  const { id } = useParams()
  const { t } = useTranslation()
  const [typingDataFilters, setTypingDataFilters] = useState(defaultTypingFilters)
  const debouncedTypingFilters = useDebounce(typingDataFilters, 300)

  useEffect(() => {
    setTypingDataFilters(defaultTypingFilters)
  }, [props.id])

  useEffect(() => {
    handleChangeFiltersData({ ...dataFiltered, ...debouncedTypingFilters, page: 0 })
  }, [debouncedTypingFilters])

  function renderInputFilter(filter) {
    return <Input
      icon={filter.icon && { name: filter.icon, circular: true, link: true }}
      placeholder={t(filter.placeholder)}
      key={filter.key}
      type={filter.subType}
      value={typingDataFilters[filter.key]}
      onChange={(e, data) => setTypingDataFilters({ ...typingDataFilters, [filter.key]: data.value })}
    />
  }

  function renderSelectFilter(filter) {
    const removeDropdown = id === milkSamplesIDs.dailyValues && filter.key === 'inhibitor'
    const displayFilter = filter.filterDisplayIds.find(idFilterDisplay => idFilterDisplay === id)
    return !removeDropdown && displayFilter && <Dropdown
      placeholder={t(filter.placeholder)}
      key={filter.key}
      selectOnBlur={false}
      clearable
      selection
      value={typingDataFilters[filter.key]}
      options={options[filter.optionsKey]?.map(month => ({ value: month.key, text: month.label }))}
      onChange={(e, data) => setTypingDataFilters({ ...typingDataFilters, [filter.key]: data.value })}
    />
  }

  return <FiltersWrapper>
    {checkedFilters.map(milkFilter => {
      switch (milkFilter.type) {
        case 'input':
          return renderInputFilter(milkFilter)
        case 'select':
          return renderSelectFilter(milkFilter)
        default:
          return
      }
    })}
  </FiltersWrapper>
}
export default Filters